<template>
  <div class="pagination-group">
    <button
      type="button"
      class="arrow-button first-button mr-10 mobile-mr-10"
      data-test="btn-first"
      :disabled="isLoading || currentPage === 1"
      @click="firstPage"
    >
      <i class="fa fa-step-backward" />
    </button>

    <button
      type="button"
      class="arrow-button"
      data-test="btn-prev"
      :disabled="isLoading || currentPage === 1"
      @click="prevPage"
    >
      <i class="fa fa-caret-left fa-lg" />
    </button>

    <span
      class="page-number text-center"
      data-test="span-page-num"
    > {{ currentPage }} / {{ totalPages }} </span>

    <button
      type="button"
      class="arrow-button"
      data-test="btn-next"
      :disabled="isLoading || currentPage === totalPages"
      @click="nextPage"
    >
      <i class="fa fa-caret-right fa-lg" />
    </button>

    <button
      type="button"
      class="arrow-button last-button ml-10 mobile-ml-10"
      data-test="btn-last"
      :disabled="isLoading || currentPage === totalPages"
      @click="lastPage"
    >
      <i class="fa fa-step-forward" />
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
  currentPage: {
    type: Number,
    default: 1,
  },
  totalPages: {
    type: Number,
    default: 1,
  },
});

const emit = defineEmits(['loadPageData']);

const firstPage = () => {
  emit('loadPageData', 1);
};

const prevPage = () => {
  emit('loadPageData', props.currentPage - 1);
};

const nextPage = () => {
  emit('loadPageData', props.currentPage + 1);
};

const lastPage = () => {
  emit('loadPageData', props.totalPages);
};
</script>

<style lang="scss">
.pagination-group {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  .arrow-button {
    padding: 0 !important;
    border-color: transparent;
    background: unset;
    font-size: 20px !important;
    min-width: unset;
    outline: none;
    cursor: pointer;
    &:hover {
      background: transparent;
      color: #eb5e38;
    }
    &:disabled {
      pointer-events: none;
    }
  }
  .page-number {
    font-size: 16px;
    font-weight: bold;
    min-width: 70px;
    margin-left: 5px;
    margin-right: 5px;
  }
}
</style>
